// 专业数据
export const programsData = [
  {
    id: 'p001',
    name: '工商管理硕士 (MBA)',
    nameEn: 'Master of Business Administration',
    category: '商科',
    level: '硕士',
    duration: '1.5年',
    language: '英语',
    tuitionFee: {
      local: 45000,
      international: 55000,
      currency: 'MYR'
    },
    university: {
      id: 'u001',
      name: '马来亚大学',
      nameEn: 'University of Malaya',
      logo: '/images/universities/um-logo.png',
      ranking: 1
    },
    description: '提供全面的商业管理知识和技能，培养具有国际视野的管理人才。',
    requirements: {
      academic: '学士学位，CGPA 3.0以上',
      language: '雅思6.5或托福90',
      experience: '2年以上工作经验',
      documents: ['学位证书', '成绩单', '推荐信', '个人陈述', '工作证明']
    },
    curriculum: [
      '战略管理',
      '财务管理',
      '营销管理',
      '人力资源管理',
      '运营管理',
      '国际商务',
      '领导力发展',
      '商业伦理'
    ],
    careerProspects: [
      '高级管理人员',
      '企业顾问',
      '投资分析师',
      '项目经理',
      '创业者'
    ],
    applicationDeadline: '2024-08-31',
    intakeMonths: ['九月'],
    scholarship: true,
    scholarshipAmount: 10000,
    tags: ['热门专业', '高就业率', '奖学金'],
    featured: true,
    image: '/images/programs/mba.jpg'
  },
  {
    id: 'p002',
    name: '计算机科学学士',
    nameEn: 'Bachelor of Computer Science',
    category: '计算机科学',
    level: '学士',
    duration: '4年',
    language: '英语',
    tuitionFee: {
      local: 32000,
      international: 38000,
      currency: 'MYR'
    },
    university: {
      id: 'u002',
      name: '马来西亚理科大学',
      nameEn: 'Universiti Sains Malaysia',
      logo: '/images/universities/usm-logo.png',
      ranking: 2
    },
    description: '全面的计算机科学教育，涵盖软件开发、人工智能、网络安全等前沿技术。',
    requirements: {
      academic: '高中毕业，数学成绩优秀',
      language: '雅思6.0或托福80',
      experience: '无工作经验要求',
      documents: ['高中毕业证', '成绩单', '个人陈述']
    },
    curriculum: [
      '编程基础',
      '数据结构与算法',
      '数据库系统',
      '软件工程',
      '人工智能',
      '网络安全',
      '移动应用开发',
      '毕业项目'
    ],
    careerProspects: [
      '软件工程师',
      '系统分析师',
      '数据科学家',
      '网络安全专家',
      '产品经理'
    ],
    applicationDeadline: '2024-07-15',
    intakeMonths: ['九月', '二月'],
    scholarship: true,
    scholarshipAmount: 8000,
    tags: ['热门专业', 'STEM', '高薪'],
    featured: true,
    image: '/images/programs/computer-science.jpg'
  },
  {
    id: 'p003',
    name: '医学博士',
    nameEn: 'Doctor of Medicine',
    category: '医学',
    level: '博士',
    duration: '6年',
    language: '英语',
    tuitionFee: {
      local: 120000,
      international: 150000,
      currency: 'MYR'
    },
    university: {
      id: 'u001',
      name: '马来亚大学',
      nameEn: 'University of Malaya',
      logo: '/images/universities/um-logo.png',
      ranking: 1
    },
    description: '六年制医学学位课程，培养具备扎实医学理论和临床技能的医生。',
    requirements: {
      academic: '高中毕业，生物、化学、物理成绩优秀',
      language: '雅思7.0或托福100',
      experience: '无工作经验要求',
      documents: ['高中毕业证', '成绩单', '推荐信', '个人陈述', '健康证明']
    },
    curriculum: [
      '基础医学',
      '临床医学',
      '病理学',
      '药理学',
      '内科学',
      '外科学',
      '临床实习',
      '医学研究'
    ],
    careerProspects: [
      '临床医生',
      '专科医生',
      '医学研究员',
      '医院管理',
      '公共卫生专家'
    ],
    applicationDeadline: '2024-06-30',
    intakeMonths: ['九月'],
    scholarship: false,
    tags: ['专业认证', '高门槛', '社会地位'],
    featured: true,
    image: '/images/programs/medicine.jpg'
  },
  {
    id: 'p004',
    name: '电子工程学士',
    nameEn: 'Bachelor of Electronic Engineering',
    category: '工程',
    level: '学士',
    duration: '4年',
    language: '英语',
    tuitionFee: {
      local: 35000,
      international: 42000,
      currency: 'MYR'
    },
    university: {
      id: 'u003',
      name: '马来西亚国立大学',
      nameEn: 'Universiti Kebangsaan Malaysia',
      logo: '/images/universities/ukm-logo.png',
      ranking: 3
    },
    description: '培养电子工程领域的专业人才，涵盖电路设计、通信系统、嵌入式系统等。',
    requirements: {
      academic: '高中毕业，数学、物理成绩优秀',
      language: '雅思6.0或托福80',
      experience: '无工作经验要求',
      documents: ['高中毕业证', '成绩单', '个人陈述']
    },
    curriculum: [
      '电路分析',
      '数字电子学',
      '模拟电子学',
      '信号与系统',
      '通信工程',
      '嵌入式系统',
      '工程项目',
      '实习训练'
    ],
    careerProspects: [
      '电子工程师',
      '硬件工程师',
      '通信工程师',
      '系统集成工程师',
      '技术顾问'
    ],
    applicationDeadline: '2024-07-31',
    intakeMonths: ['九月', '二月'],
    scholarship: true,
    scholarshipAmount: 6000,
    tags: ['STEM', '工程认证', '实用性强'],
    featured: false,
    image: '/images/programs/electronic-engineering.jpg'
  },
  {
    id: 'p005',
    name: '国际关系硕士',
    nameEn: 'Master of International Relations',
    category: '社会科学',
    level: '硕士',
    duration: '2年',
    language: '英语',
    tuitionFee: {
      local: 28000,
      international: 35000,
      currency: 'MYR'
    },
    university: {
      id: 'u002',
      name: '马来西亚理科大学',
      nameEn: 'Universiti Sains Malaysia',
      logo: '/images/universities/usm-logo.png',
      ranking: 2
    },
    description: '深入研究国际政治、外交关系和全球治理，培养国际事务专业人才。',
    requirements: {
      academic: '学士学位，CGPA 3.0以上',
      language: '雅思6.5或托福90',
      experience: '无工作经验要求',
      documents: ['学位证书', '成绩单', '推荐信', '研究计划']
    },
    curriculum: [
      '国际政治理论',
      '外交学',
      '国际法',
      '全球治理',
      '地区研究',
      '冲突解决',
      '国际组织',
      '硕士论文'
    ],
    careerProspects: [
      '外交官',
      '国际组织职员',
      '政策分析师',
      '新闻记者',
      '学术研究员'
    ],
    applicationDeadline: '2024-08-15',
    intakeMonths: ['九月'],
    scholarship: true,
    scholarshipAmount: 5000,
    tags: ['人文社科', '国际视野', '学术导向'],
    featured: false,
    image: '/images/programs/international-relations.jpg'
  },
  {
    id: 'p006',
    name: '会计学学士',
    nameEn: 'Bachelor of Accounting',
    category: '商科',
    level: '学士',
    duration: '3年',
    language: '英语',
    tuitionFee: {
      local: 28000,
      international: 32000,
      currency: 'MYR'
    },
    university: {
      id: 'u004',
      name: '马来西亚博特拉大学',
      nameEn: 'Universiti Putra Malaysia',
      logo: '/images/universities/upm-logo.png',
      ranking: 4
    },
    description: '全面的会计学教育，涵盖财务会计、管理会计、审计等核心领域。',
    requirements: {
      academic: '高中毕业，数学成绩良好',
      language: '雅思6.0或托福80',
      experience: '无工作经验要求',
      documents: ['高中毕业证', '成绩单', '个人陈述']
    },
    curriculum: [
      '财务会计',
      '管理会计',
      '成本会计',
      '审计学',
      '税务',
      '财务管理',
      '会计信息系统',
      '实习项目'
    ],
    careerProspects: [
      '注册会计师',
      '财务分析师',
      '审计师',
      '税务顾问',
      '财务经理'
    ],
    applicationDeadline: '2024-07-20',
    intakeMonths: ['九月', '二月'],
    scholarship: true,
    scholarshipAmount: 4000,
    tags: ['专业资格', '就业稳定', '实用性强'],
    featured: false,
    image: '/images/programs/accounting.jpg'
  },
  {
    id: 'p007',
    name: '心理学硕士',
    nameEn: 'Master of Psychology',
    category: '心理学',
    level: '硕士',
    duration: '2年',
    language: '英语',
    tuitionFee: {
      local: 32000,
      international: 38000,
      currency: 'MYR'
    },
    university: {
      id: 'u005',
      name: '马来西亚工艺大学',
      nameEn: 'Universiti Teknologi Malaysia',
      logo: '/images/universities/utm-logo.png',
      ranking: 5
    },
    description: '深入研究人类行为和心理过程，培养心理学研究和应用专业人才。',
    requirements: {
      academic: '心理学或相关学士学位，CGPA 3.0以上',
      language: '雅思6.5或托福90',
      experience: '相关实习或工作经验优先',
      documents: ['学位证书', '成绩单', '推荐信', '研究计划', '个人陈述']
    },
    curriculum: [
      '高级心理学理论',
      '研究方法',
      '统计分析',
      '认知心理学',
      '社会心理学',
      '临床心理学',
      '心理评估',
      '硕士论文'
    ],
    careerProspects: [
      '临床心理学家',
      '心理咨询师',
      '研究员',
      '人力资源专家',
      '教育心理学家'
    ],
    applicationDeadline: '2024-08-31',
    intakeMonths: ['九月'],
    scholarship: true,
    scholarshipAmount: 6000,
    tags: ['专业资格', '社会需求', '研究导向'],
    featured: false,
    image: '/images/programs/psychology.jpg'
  },
  {
    id: 'p008',
    name: '土木工程学士',
    nameEn: 'Bachelor of Civil Engineering',
    category: '工程',
    level: '学士',
    duration: '4年',
    language: '英语',
    tuitionFee: {
      local: 38000,
      international: 45000,
      currency: 'MYR'
    },
    university: {
      id: 'u003',
      name: '马来西亚国立大学',
      nameEn: 'Universiti Kebangsaan Malaysia',
      logo: '/images/universities/ukm-logo.png',
      ranking: 3
    },
    description: '培养土木工程专业人才，涵盖结构设计、建筑施工、基础设施建设等领域。',
    requirements: {
      academic: '高中毕业，数学、物理成绩优秀',
      language: '雅思6.0或托福80',
      experience: '无工作经验要求',
      documents: ['高中毕业证', '成绩单', '个人陈述']
    },
    curriculum: [
      '工程数学',
      '结构力学',
      '材料科学',
      '水力学',
      '土壤力学',
      '结构设计',
      '工程项目管理',
      '实习训练'
    ],
    careerProspects: [
      '土木工程师',
      '结构工程师',
      '项目经理',
      '建筑设计师',
      '工程顾问'
    ],
    applicationDeadline: '2024-07-31',
    intakeMonths: ['九月', '二月'],
    scholarship: true,
    scholarshipAmount: 7000,
    tags: ['工程认证', '基础设施', 'STEM'],
    featured: false,
    image: '/images/programs/civil-engineering.jpg'
  }
];

// 专业类别
export const programCategories = [
  { value: '', label: '全部类别' },
  { value: 'biz', label: '商业与管理' },
  { value: 'eng', label: '工程与技术' },
  { value: 'cs', label: '计算机与信息技术' },
  { value: 'sci', label: '自然科学' },
  { value: 'med', label: '医学与健康' },
  { value: 'arch', label: '建筑与设计' },
  { value: 'soc', label: '人文与社会科学' },
  { value: 'law', label: '法律' },
  { value: 'lang', label: '语言与文学' },
  { value: 'agri', label: '农业与林业' }
];


// 学位级别
export const programLevels = [
  { value: '', label: '全部级别' },
  { value: '本科', label: '学士学位' },
  { value: '硕士', label: '硕士学位' },
  { value: '博士', label: '博士学位' },
  { value: '专科', label: '文凭课程' }
];

// 学制
export const programDurations = [
  { value: '', label: '全部学制' },
  { value: '1', label: '1年' },
  { value: '1.5', label: '1.5年' },
  { value: '2', label: '2年' },
  { value: '3', label: '3年' },
  { value: '4', label: '4年' },
  { value: '5', label: '5年' },
  { value: '6', label: '6年' }
];

// 入学时间
export const intakeOptions = [
  { value: '', label: '全部入学时间' },
  { value: '1', label: '一月入学' },
  { value: '2', label: '二月入学' },
  { value: '3', label: '三月入学' },
  { value: '4', label: '四月入学' },
  { value: '5', label: '五月入学' },
  { value: '6', label: '六月入学' },
  { value: '7', label: '七月入学' },
  { value: '8', label: '八月入学' },
  { value: '9', label: '九月入学' },
  { value: '10', label: '十月入学' },
  { value: '11', label: '十一月入学' },
  { value: '12', label: '十二月入学' }
];

// 排序选项
export const programSortOptions = [
  { value: 'tuition-low', label: '学费：低到高' },
  { value: 'tuition-high', label: '学费：高到低' }
];
